import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { finalize, take } from 'rxjs';

import { Tools } from '../../../core/utils/tools';
import { NotificationService } from '../../../services/notification.service';
import { GateResource } from '../../../services/resources/gate.resource';

@Component({
    selector: 'sl-gate-qr-code',
    templateUrl: './gate-qr-code.component.html',
    styleUrls: ['./gate-qr-code.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GateQrCodeComponent implements OnInit {
    readonly isLoading = signal(true);
    readonly url = signal('');
    readonly token = signal('');

    private readonly gateResource = inject(GateResource);
    private readonly notificationService = inject(NotificationService);

    ngOnInit(): void {
        this.gateResource
            .getToken()
            .pipe(
                take(1),
                finalize(() => this.isLoading.set(false))
            )
            .subscribe(r => {
                this.token.set(r.token);
                this.url.set(`${location.protocol}//${location.host}/gate?api_key=${r.token}&ctx=${r.context}`);
            });
    }

    onCopied(): void {
        this.notificationService.showSuccess('Copied successfully');
    }

    downloadLink(): void {
        const txt = `[InternetShortcut]\nURL=${this.url()}`;
        Tools.Utils.saveFile(new Blob([txt]), 'Gate.URL', false);
    }
}
